export default __webpack_public_path__ + "static/media/brand_icon.6b4b5551.png";